import React, { Component } from 'react';
import {Spinner, Row, Col, Button } from 'react-bootstrap';
import {TokenValidation, InventoryUserMappedAction} from '../Dashboard/UserActions';
import {InventoryMaster} from '../Inventory/InventoryAction';
import {ClidReportGenerate, resetReport, ClidReportDownload, closeModalPopUp, ClientBasedOnInventory} from './ReportsActions';
import { connect } from 'react-redux';	
import ShowModalPopUp from '../ShowModalPopUp';
import DatePicker from "react-datepicker";
import moment from "moment";
import ReportsViewSummary from './ReportsViewSummary';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css';
import {URL_API_MANAGEMENT_CLIENT_VIEW_REPORT_GENERATE, URL_API_MANAGEMENT_CLIENT_VIEW_REPORT_EXCEL} from '../apiHitFile';
import _ from 'lodash';

 class ClientView extends Component { 
  constructor(props){
    super(props)
    this.state= {
      selectedclientName:[],
      selectedcenterName:[],
      selectedprocessName:[],
      selectedregionName:[],
      saveClicked:false,
      GenerateReport:false,
      toggleA:true
    }
   }
  componentDidMount(){    
    this.props.ClientBasedOnInventory()
    this.props.resetReport()
  }

  clientsName = () => {
    const{clientBasedValues} = this.props;
    let clientsName=[];
    if(!_.isEmpty(clientBasedValues)){
      clientsName =  _.filter(clientBasedValues);
      }
    return clientsName;
  }   
 
  regionName = () => {
    const{selectedclientName} = this.state;
    let regionName=[];
    if(!_.isEmpty(selectedclientName)){
      regionName =  _.filter(selectedclientName.region);
    }
    return regionName;
  }
  centerName = () => {
    const{selectedregionName} = this.state;
    let centerName=[];
    if(!_.isEmpty(selectedregionName)){
      _.map(selectedregionName, (obj)=>{
        let x = _.filter(obj.center);
        centerName.push(...x );
    }) 
    centerName=_.uniqBy(centerName, 'inventoryCenterId');
    }
    return centerName;
  }  
  processName = () => {
    const{selectedcenterName} = this.state;
    let processName=[];
    if(!_.isEmpty(selectedcenterName)){
      _.map(selectedcenterName, (obj)=>{
        let x = _.filter(obj.process);
        processName.push(...x );
    }) 
    processName=_.uniqBy(processName, 'inventoryProcessId');

    }
    return processName;
  } 
  handleSelectClient = (e) => {
    this.setState({selectedclientName: e}); 
    if(!_.isEqual(this.state.selectedclientName, e)){
      this.setState({selectedregionName:[], selectedcenterName:[], selectedprocessName:[],GenerateReport:false})
    } 
  }
  handleSelectRegion = (e) => {
    this.setState({selectedregionName: e});  
    if(!_.isEqual(this.state.selectedregionName, e)){
      this.setState({selectedcenterName:[], selectedprocessName:[],GenerateReport:false})
    } 
  }
  handleSelectCenter = (e) => {
    this.setState({selectedcenterName: e});  
    if(!_.isEqual(this.state.selectedcenterName, e)){
      this.setState({selectedprocessName:[],GenerateReport:false})
    } 
  }
  handleSelectProcess = (e) => {
    this.setState({selectedprocessName: e});  
    if(!_.isEqual(this.state.selectedprocessName, e)){
      this.setState({GenerateReport:false})
    } 
  }

  handleChangeStart = (date) => {
    this.setState({startDate: date});
  }
  validateInput = () =>{
    const {selectedregionName, selectedcenterName, selectedclientName, startDate, selectedprocessName} = this.state
    if(!_.isEmpty(selectedregionName) && !_.isEmpty(selectedcenterName) && !_.isEmpty(selectedclientName) && !_.isEmpty(selectedprocessName) 
     && typeof startDate !== "undefined"){
      return true
    }
  } 
  generateReport = () => {
    const {selectedregionName, selectedcenterName, selectedclientName, selectedprocessName, startDate} = this.state
    console.log('state', this.state)
    let centerObj = _.map(selectedcenterName, (obj) => {
      return ({[obj.inventoryCenterId]:obj.inventoryCenterName})
    })
    let processObj = _.map(selectedprocessName, (obj) => {
      return ({[obj.inventoryProcessId]:obj.inventoryProcessName})
    })
    let regionObj = _.map(selectedregionName, (obj) => {
      return ({[obj.inventoryRegionId]:obj.inventoryRegionName})
    })
    
    centerObj = Object.assign({}, ...centerObj)
    processObj = Object.assign({}, ...processObj)
    regionObj = Object.assign({}, ...regionObj)

    console.log('state', centerObj,processObj,regionObj)
    let obj = {
      "date":moment(startDate).format('YYYY-MM-DD'),
      "clients":{[selectedclientName.inventoryClientId]:selectedclientName.inventoryClientName},
      "centers":centerObj,
      "processes":processObj,
      "regions":regionObj
    }
    this.props.TokenValidation()
    this.props.ClidReportGenerate(obj, URL_API_MANAGEMENT_CLIENT_VIEW_REPORT_GENERATE)
    this.setState({GenerateReport:true})
    // this.setState({GenerateReport:true}, ()=>this.handleToggle())
  }
  handleToggle = () =>{
    this.setState((prevState) =>{
      return {toggleA: !prevState.toggleA};
    })
  }
  downloadReport= () =>{
    const {selectedregionName, selectedcenterName, selectedclientName, selectedprocessName, startDate} = this.state
    let centerObj = _.map(selectedcenterName, (obj) => {
      return ({[obj.inventoryCenterId]:obj.inventoryCenterName})
    })
    let processObj = _.map(selectedprocessName, (obj) => {
      return ({[obj.inventoryProcessId]:obj.inventoryProcessName})
    })
    let regionObj = _.map(selectedregionName, (obj) => {
      return ({[obj.inventoryRegionId]:obj.inventoryRegionName})
    })
    centerObj = Object.assign({}, ...centerObj)
    processObj = Object.assign({}, ...processObj)
    regionObj = Object.assign({}, ...regionObj)
    let obj = {
      "date":moment(startDate).format('YYYY-MM-DD'),
      "clients":{[selectedclientName.inventoryClientId]:selectedclientName.inventoryClientName},
      "centers":centerObj,
      "processes":processObj,
      "regions":regionObj
    }
     this.props.TokenValidation()
     this.props.ClidReportDownload(obj, URL_API_MANAGEMENT_CLIENT_VIEW_REPORT_EXCEL, "CLIENT_VIEW.xlsx")
   }

	render(){
    const {GenerateReport, toggleA} = this.state;  
		let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
    }	
		return(
			<div  className={(style) ? 'user' : "userSmall"}>			
				{(this.props.showerror === true) ?
        <ShowModalPopUp message={this.props.errmessage} falseShowModalPopUp={this.props.closeModalPopUp}/> : null}
        {this.props.isPending === true ? <p className='spinner'><Spinner animation="grow" role="status" size='lg'/>
        Loading...</p> : null}
        <div>
          <h6 onClick={this.handleToggle} >
          {toggleA ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>} <b>&nbsp;REPORT CRITERIA</b></h6>  
        <div className={toggleA ? '': 'assesmentHide'}>  
          <Row className="marginBottom">  
            <Col>
              <label><b>CLIENT NAME<span className="RedColoring"> *</span></b></label>
              <Picky keepOpen={false}
              value={this.state.selectedclientName}
              options={this.clientsName()}
              onChange={this.handleSelectClient}
              open={false}
              valueKey="inventoryClientId"
              labelKey="inventoryClientName"
              multiple={false}
              includeSelectAll={true}
              includeFilter={false}
              placeholder='Select Clients'
              dropdownHeight={600}
              />
          </Col> 
            <Col>
              <label><b>REGION NAME<span className="RedColoring"> *</span></b></label>
              <Picky keepOpen={false}
              value={this.state.selectedregionName}
              options={this.regionName()}
              onChange={this.handleSelectRegion}
              open={false}
              valueKey="inventoryRegionId"
              labelKey="inventoryRegionName"
              multiple={true}
              includeSelectAll={true}
              includeFilter={false}
              placeholder='Select Region'
              dropdownHeight={600}
              />
          </Col> 
          <Col>
              <label><b>CENTER NAME<span className="RedColoring"> *</span></b></label>
              <Picky keepOpen={false}
              value={this.state.selectedcenterName}
              options={this.centerName()}
              onChange={this.handleSelectCenter}
              open={false}
              valueKey="inventoryCenterId"
              labelKey="inventoryCenterName"
              multiple={true}
              includeSelectAll={true}
              includeFilter={false}
              placeholder='Select Centers'
              dropdownHeight={600}
              />
          </Col> 
          <Col>
              <label><b>PROCESS NAME<span className="RedColoring"> *</span></b></label>
              <Picky keepOpen={false}
              value={this.state.selectedprocessName}
              options={this.processName()}
              onChange={this.handleSelectProcess}
              open={false}
              valueKey="inventoryProcessId"
              labelKey="inventoryProcessName"
              multiple={true}
              includeSelectAll={true}
              includeFilter={false}
              placeholder='Select Process'
              dropdownHeight={600}
              />
          </Col>
          <Col>
          <label><b>DATE<span className="RedColoring"> *</span></b></label>
          <DatePicker
          selected={this.state.startDate}
          className='myDatePicker'
          selectsStart
          showMonthDropdown
          startDate={this.state.startDate}
          onChange={this.handleChangeStart}
          dateFormat="dd/MM/yyyy"
          placeholderText="Select Date"          
         />
          </Col> 
          </Row> 
       </div>
          <Button className='buttonwidth alignInline alignRight' disabled={!this.validateInput()}
            onClick={this.generateReport}>Generate Report</Button>
          {((GenerateReport === true) && !_.isEmpty(this.props.reportData)  && !_.isEmpty(this.props.reportData.value)) ? 
          <Button className='buttonwidth alignInline alignRight' onClick={this.downloadReport}>Download Report</Button> : null}
          {((GenerateReport === true) && !_.isEmpty(this.props.reportData)) ?
          <ReportsViewSummary reportData={this.props.reportData} />
          : null }
        </div> 
			</div>)
	}

}
function mapStateToProps(state){
  return{
    size: state.UserReducer.large,    
    clientBasedValues: state.ReportsReducer.clientBasedValues,
    reportData: state.ReportsReducer.reportData, 
    isPending: state.ReportsReducer.isPending,
    showerror:  state.ReportsReducer.showerror, 
    errmessage:  state.ReportsReducer.errmessage
   }  
}

const mapDispatchToProps = (dispatch) => ({
  ClientBasedOnInventory:  (a) =>dispatch(ClientBasedOnInventory(a)),
  ClidReportGenerate: (a, b) => dispatch(ClidReportGenerate(a,b)),
  ClidReportDownload: (a, b, c) => dispatch(ClidReportDownload(a, b, c)),
  resetReport: () => dispatch(resetReport()),
  TokenValidation : () => dispatch(TokenValidation()),
  closeModalPopUp:  () =>dispatch(closeModalPopUp()), 
  
})


export default connect(mapStateToProps, mapDispatchToProps)(ClientView);     